// import { useState, useEffect } from 'react';
// import '../Assests/Attendance.css';
// import {
//   getAttendanceByProfile,
//   getTodayAttendance,
//   checkInUser,
//   checkOutUser,
//   autoClosePastSessions,
//   getAttendance
// } from '../Db_Connections/AttendanceApi';

// const SHIFT_START_HOUR = 9;
// const SHIFT_END_HOUR = 18;

// export default function Attendance() {
//   // ✅ view + week/month selection
//   const [viewMode, setViewMode] = useState('week'); // 'week' | 'month'
//   const [selectedWeekOffset, setSelectedWeekOffset] = useState(0);
//   const [selectedMonth, setSelectedMonth] = useState(() => {
//     const d = new Date();
//     return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
//   });

//   // ✅ user dropdown selection
//   const [selectedUserKey, setSelectedUserKey] = useState('ALL'); // 'ALL' | employeeName string

//   // User view data
//   const [dbData, setDbData] = useState([]);
//   const [todayRecord, setTodayRecord] = useState(null);

//   // Admin view data
//   const [adminData, setAdminData] = useState([]);
//   const [adminLoading, setAdminLoading] = useState(false);

//   // Timer (user only)
//   const [isTimerRunning, setIsTimerRunning] = useState(false);
//   const [elapsedSeconds, setElapsedSeconds] = useState(0);

//   const user = JSON.parse(sessionStorage.getItem('auth'));
//   const isAdmin = user?.role === 'Admin';

//   const currentUserName =
//     user?.first_name || user?.last_name
//       ? `${user?.first_name || ''} ${user?.last_name || ''}`.trim()
//       : (user?.name || user?.email || 'User');

//   // ============ DATE HELPERS ============
//   const getWeekDatesByOffset = (weekOffset) => {
//     const today = new Date();
//     const currentDay = today.getDay();
//     const diff = today.getDate() - currentDay + (weekOffset * 7);
//     const weekStart = new Date(today.setDate(diff));
//     const days = [];
//     for (let i = 0; i < 7; i++) {
//       const d = new Date(weekStart);
//       d.setDate(weekStart.getDate() + i);
//       days.push(d);
//     }
//     return days;
//   };

//   const weekDates = getWeekDatesByOffset(selectedWeekOffset);
//   const startDate = weekDates[0];
//   const endDate = weekDates[6];
//   const startStr = startDate.toISOString().split('T')[0];
//   const endStr = endDate.toISOString().split('T')[0];

//   const getMonthRange = (yyyymm) => {
//     const [y, m] = yyyymm.split('-').map(Number);
//     const end = new Date(y, m, 0);
//     const startS = `${y}-${String(m).padStart(2, '0')}-01`;
//     const endS = `${y}-${String(m).padStart(2, '0')}-${String(end.getDate()).padStart(2, '0')}`;
//     return { startS, endS };
//   };

//   const { startS: monthStartStr, endS: monthEndStr } = getMonthRange(selectedMonth);

//   const formatDateRange = () =>
//     `${startDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })} - ${endDate.toLocaleDateString('en-GB', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric'
//     })}`;

//   const isToday = (date) => {
//     const t = new Date();
//     return date.getDate() === t.getDate() && date.getMonth() === t.getMonth() && date.getFullYear() === t.getFullYear();
//   };

//   const formatTime = (totalSeconds) => {
//     const h = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
//     const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
//     const s = String(totalSeconds % 60).padStart(2, '0');
//     return `${h}:${m}:${s}`;
//   };

//   const formatAMPM = (dateStr) => {
//     if (!dateStr) return '--:--';
//     return new Date(dateStr).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
//   };

//   const calculateLateEarly = (record) => {
//     let lateBy = null;
//     let earlyBy = null;

//     if (record.check_in_time) {
//       const checkIn = new Date(record.check_in_time);
//       const shiftStart = new Date(checkIn);
//       shiftStart.setHours(SHIFT_START_HOUR, 0, 0);
//       if (checkIn > shiftStart) {
//         const diff = Math.floor((checkIn - shiftStart) / 1000);
//         lateBy = formatTime(diff);
//       }
//     }

//     if (record.check_out_time) {
//       const checkOut = new Date(record.check_out_time);
//       const shiftEnd = new Date(checkOut);
//       shiftEnd.setHours(SHIFT_END_HOUR, 0, 0);
//       if (checkOut < shiftEnd) {
//         const diff = Math.floor((shiftEnd - checkOut) / 1000);
//         earlyBy = formatTime(diff);
//       }
//     }

//     return { lateBy, earlyBy };
//   };

//   // ============ FETCH USER ============
//   const fetchUserAttendanceData = async () => {
//     if (!user) return;

//     await autoClosePastSessions(user.id);

//     const { data } = await getAttendanceByProfile(user.id);
//     if (data) setDbData(data);

//     const { data: today } = await getTodayAttendance(user.id);

//     if (today) {
//       setTodayRecord(today);

//       if (today.check_in_time && !today.check_out_time) {
//         const startTime = new Date(today.check_in_time).getTime();
//         const now = new Date().getTime();
//         const diffSec = Math.floor((now - startTime) / 1000);
//         setElapsedSeconds(diffSec > 0 ? diffSec : 0);
//         setIsTimerRunning(true);
//       } else if (today.working_hours) {
//         setIsTimerRunning(false);
//         setElapsedSeconds(Number(today.working_hours) * 3600);
//       }
//     } else {
//       setTodayRecord(null);
//       setIsTimerRunning(false);
//       setElapsedSeconds(0);
//     }
//   };

//   // ============ FETCH ADMIN ============
//   const fetchAdminData = async () => {
//     setAdminLoading(true);
//     try {
//       const res = await getAttendance();
//       setAdminData(res?.data || []);
//     } finally {
//       setAdminLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!user) return;
//     if (isAdmin) fetchAdminData();
//     else fetchUserAttendanceData();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isAdmin]);

//   // ============ TIMER (USER ONLY) ============
//   useEffect(() => {
//     let intervalId;
//     if (!isAdmin && isTimerRunning) {
//       intervalId = setInterval(() => setElapsedSeconds((prev) => prev + 1), 1000);
//     }
//     return () => clearInterval(intervalId);
//   }, [isTimerRunning, isAdmin]);

//   // ============ CHECK-IN / CHECK-OUT (USER ONLY) ============
//   const handleCheckInOut = async () => {
//     if (!user || isAdmin) return;

//     if (!isTimerRunning && (!todayRecord || !todayRecord.check_out_time)) {
//       const { data, error } = await checkInUser(user.id);
//       if (error) alert("Error Checking In: " + error.message);
//       else {
//         setTodayRecord(data);
//         setElapsedSeconds(0);
//         setIsTimerRunning(true);
//         fetchUserAttendanceData();
//       }
//     } else if (isTimerRunning) {
//       const { data, error } = await checkOutUser(todayRecord.id);
//       if (error) alert("Error Checking Out: " + error.message);
//       else {
//         setIsTimerRunning(false);
//         setTodayRecord(data);
//         fetchUserAttendanceData();
//         alert(`Checked Out Successfully!\nDate: ${data.attendance_date}\nWorking Hours: ${data.working_hours} hrs`);
//       }
//     }
//   };

//   // ============ TODAY SUMMARY (USER) ============
//   const todaySummary = todayRecord
//     ? {
//         checkIn: formatAMPM(todayRecord.check_in_time),
//         checkOut: todayRecord.check_out_time ? formatAMPM(todayRecord.check_out_time) : '--:--',
//         hours: isTimerRunning ? formatTime(elapsedSeconds) : (todayRecord.working_hours ? `${todayRecord.working_hours} hrs` : '00:00:00')
//       }
//     : { checkIn: '--:--', checkOut: '--:--', hours: '00:00:00' };

//   const todayLabel = new Date().toLocaleDateString('en-GB', { weekday: 'short', day: '2-digit', month: 'short' });

//   // ============ FILTER DATA BY WEEK/MONTH ============
//   const inSelectedRange = (row) => {
//     if (viewMode === 'week') return row.attendance_date >= startStr && row.attendance_date <= endStr;
//     return row.attendance_date >= monthStartStr && row.attendance_date <= monthEndStr;
//   };

//   const filteredUser = dbData.filter(inSelectedRange);

//   // ✅ Admin filtered (range + optional selected user)
//   const filteredAdmin = adminData
//     .filter(inSelectedRange)
//     .filter((row) => {
//       if (selectedUserKey === 'ALL') return true;
//       const employeeName = row?.profiles
//         ? `${row.profiles.first_name || ''} ${row.profiles.last_name || ''}`.trim()
//         : `Employee (${row.profile_id})`;
//       return employeeName === selectedUserKey;
//     });

//   // ============ ADMIN GROUP ============
//   const buildAdminRowsByEmployee = () => {
//     const empMap = {};
//     filteredAdmin.forEach((row) => {
//       const employeeName = row?.profiles
//         ? `${row.profiles.first_name || ''} ${row.profiles.last_name || ''}`.trim()
//         : `Employee (${row.profile_id})`;

//       if (!empMap[employeeName]) empMap[employeeName] = {};
//       empMap[employeeName][row.attendance_date] = row;
//     });

//     return Object.entries(empMap).map(([name, byDate]) => ({ name, byDate }));
//   };

//   const adminEmployees = buildAdminRowsByEmployee();

//   // ✅ Build dropdown users list (adminData se)
//   const adminUserOptions = (() => {
//     const set = new Set();
//     adminData.forEach((row) => {
//       const name = row?.profiles
//         ? `${row.profiles.first_name || ''} ${row.profiles.last_name || ''}`.trim()
//         : null;
//       if (name) set.add(name);
//     });
//     return Array.from(set).sort((a, b) => a.localeCompare(b));
//   })();

//   const buildMonths = () => {
//     const y = new Date().getFullYear();
//     const months = [];
//     for (let m = 1; m <= 12; m++) {
//       const value = `${y}-${String(m).padStart(2, '0')}`;
//       const label = new Date(y, m - 1, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
//       months.push({ value, label });
//     }
//     return months;
//   };

//   const weekOptions = [
//     { value: 0, label: 'Week 1 (Current)' },
//     { value: -1, label: 'Week 2 (Last Week)' },
//     { value: -2, label: 'Week 3' },
//     { value: -3, label: 'Week 4' },
//   ];

//   return (
//     <div className="page-container">
//       <div className="tabs-container">
//         <div className="tab active">
//           {isAdmin ? "All Employees Attendance Summary" : "Attendance Summary"}
//         </div>
//       </div>

//       <div className="content-wrapper">
//         {/* ✅ DROPDOWNS: Name + Week/Month */}
//         <div className="attendance-filters">
//           {/* ✅ Name dropdown */}
//           <select
//             className="attendance-select user-select"
//             value={selectedUserKey}
//             onChange={(e) => setSelectedUserKey(e.target.value)}
//             disabled={!isAdmin}
//           >
//             {isAdmin && <option value="ALL">All Employees</option>}
//             {!isAdmin && <option value={currentUserName}>{currentUserName}</option>}

//             {isAdmin && adminUserOptions.map((name) => (
//               <option key={name} value={name}>{name}</option>
//             ))}
//           </select>

//           <select
//             className="attendance-select"
//             value={viewMode}
//             onChange={(e) => setViewMode(e.target.value)}
//           >
//             <option value="week">Week</option>
//             <option value="month">Month</option>
//           </select>

//           {viewMode === 'week' ? (
//             <select
//               className="attendance-select"
//               value={selectedWeekOffset}
//               onChange={(e) => setSelectedWeekOffset(Number(e.target.value))}
//             >
//               {weekOptions.map((w) => (
//                 <option key={w.value} value={w.value}>{w.label}</option>
//               ))}
//             </select>
//           ) : (
//             <select
//               className="attendance-select"
//               value={selectedMonth}
//               onChange={(e) => setSelectedMonth(e.target.value)}
//             >
//               {buildMonths().map((m) => (
//                 <option key={m.value} value={m.value}>{m.label}</option>
//               ))}
//             </select>
//           )}
//         </div>

//         {/* Header range */}
//         {viewMode === 'week' && (
//           <div className="schedule-header">
//             <div className="date-navigation">
//               <button className="nav-btn" onClick={() => setSelectedWeekOffset((c) => c - 1)}>‹</button>
//               <button className="calendar-icon-btn">📅</button>
//               <button className="nav-btn" onClick={() => setSelectedWeekOffset((c) => c + 1)}>›</button>
//               <span className="date-range">{formatDateRange()}</span>
//             </div>
//           </div>
//         )}

//         {/* ✅ USER: check-in UI (admin hidden) */}
//         {!isAdmin && (
//           <>
//             <div className="shift-info-card">
//               <div className="shift-details">
//                 <span className="shift-name">General [  10:00 AM - 07:30 PM ]</span>
//                 <input type="text" className="notes-input" placeholder="Add notes (optional)" />
//               </div>
//               <button
//                 className="check-in-btn"
//                 onClick={handleCheckInOut}
//                 style={{ background: isTimerRunning ? '#e74c3c' : '#27ae60' }}
//                 disabled={todayRecord?.check_out_time}
//               >
//                 <span>{todayRecord?.check_out_time ? 'Completed' : (isTimerRunning ? 'Check Out' : 'Check In')}</span>
//                 <span className="check-in-time">{formatTime(elapsedSeconds)} Hrs</span>
//               </button>
//             </div>

//             <div className="today-summary-card">
//               <div className="today-left">
//                 <div className="today-day">{todayLabel}</div>
//               </div>
//               <div className="today-right">
//                 <div className="today-row"><span>Check-in</span><span>{todaySummary.checkIn}</span></div>
//                 <div className="today-row"><span>Check-out</span><span>{todaySummary.checkOut}</span></div>
//                 <div className="today-row"><span>Working Hrs</span><span>{todaySummary.hours}</span></div>
//               </div>
//             </div>
//           </>
//         )}

//         {/* ✅ ADMIN VIEW */}
//         {isAdmin ? (
//           <div className="attendance-container">
//             {adminLoading ? (
//               <div style={{ padding: 12 }}>Loading...</div>
//             ) : adminEmployees.length === 0 ? (
//               <div style={{ padding: 12 }}>No attendance data found.</div>
//             ) : (
//               adminEmployees.map((emp) => (
//                 <div key={emp.name} style={{ marginBottom: 18 }}>
//                   <div style={{ padding: '10px 12px', fontWeight: 800 }}>👤 {emp.name}</div>

//                   {viewMode === 'week' ? (
//                     weekDates.map((date, idx) => {
//                       const dateStr = date.toISOString().split('T')[0];
//                       const isWeekend = idx === 0;
//                       const record = emp.byDate[dateStr];
//                       const isAbsent = !isWeekend && !record;

//                       const display = record || {
//                         attendance_date: dateStr,
//                         status: isAbsent ? 'Absent' : (isWeekend ? 'Weekend' : 'No Data'),
//                         check_in_time: null,
//                         check_out_time: null,
//                         working_hours: null,
//                       };

//                       const { lateBy, earlyBy } = record ? calculateLateEarly(record) : { lateBy: null, earlyBy: null };

//                       return (
//                         <div key={dateStr} className="day-row">
//                           <div className="day-cell">
//                             <span className="day-name">{date.toLocaleDateString('en-US', { weekday: 'short' })}</span>
//                             <span className={`day-number ${isToday(date) ? 'today' : ''}`}>{date.getDate()}</span>
//                             <span style={{ fontSize: 11, color: '#6b7280' }}>{display.attendance_date}</span>
//                           </div>

//                           <div className="time-info">
//                             <span className="time-value">{display.check_in_time ? formatAMPM(display.check_in_time) : '--:--'}</span>
//                             {lateBy && <span className="time-label late">Late {lateBy}</span>}
//                             {isAbsent && <span className="time-label late">Absent</span>}
//                           </div>

//                           <div className="time-info">
//                             <span className="time-value">{display.check_out_time ? formatAMPM(display.check_out_time) : '--:--'}</span>
//                             {earlyBy && <span className="time-label early">Early {earlyBy}</span>}
//                           </div>

//                           <div className="hours-worked">
//                             <div>{display.working_hours ? `${display.working_hours} Hrs` : '00:00'}</div>
//                             {!isWeekend && (
//                               <div style={{ fontSize: '12px', color: isAbsent ? '#e74c3c' : '#6b7280' }}>
//                                 {display.status}
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       );
//                     })
//                   ) : (
//                     Object.values(emp.byDate)
//                       .filter((r) => r.attendance_date >= monthStartStr && r.attendance_date <= monthEndStr)
//                       .sort((a, b) => a.attendance_date.localeCompare(b.attendance_date))
//                       .map((record) => {
//                         const { lateBy, earlyBy } = calculateLateEarly(record);
//                         return (
//                           <div key={record.id} className="day-row">
//                             <div className="day-cell">
//                               <span className="day-name">{record.attendance_date}</span>
//                             </div>

//                             <div className="time-info">
//                               <span className="time-value">{record.check_in_time ? formatAMPM(record.check_in_time) : '--:--'}</span>
//                               {lateBy && <span className="time-label late">Late {lateBy}</span>}
//                             </div>

//                             <div className="time-info">
//                               <span className="time-value">{record.check_out_time ? formatAMPM(record.check_out_time) : '--:--'}</span>
//                               {earlyBy && <span className="time-label early">Early {earlyBy}</span>}
//                             </div>

//                             <div className="hours-worked">
//                               <div>{record.working_hours ? `${record.working_hours} Hrs` : '00:00'}</div>
//                               <div style={{ fontSize: '12px', color: '#6b7280' }}>
//                                 {record.status || (record.check_in_time ? 'Present' : 'Absent')}
//                               </div>
//                             </div>
//                           </div>
//                         );
//                       })
//                   )}
//                 </div>
//               ))
//             )}
//           </div>
//         ) : (
//           // ✅ USER VIEW
//           <div className="attendance-container">
//             {viewMode === 'week' ? (
//               weekDates.map((date, index) => {
//                 const dateStr = date.toISOString().split('T')[0];
//                 const record = filteredUser.find(d => d.attendance_date === dateStr);

//                 const isWeekend = index === 0;
//                 const isAbsent = !isWeekend && !record;

//                 const display = record || {
//                   attendance_date: dateStr,
//                   status: isAbsent ? 'Absent' : (isWeekend ? 'Weekend' : 'No Data'),
//                   check_in_time: null,
//                   check_out_time: null,
//                   working_hours: null,
//                 };

//                 const { lateBy, earlyBy } = record ? calculateLateEarly(record) : { lateBy: null, earlyBy: null };

//                 return (
//                   <div key={index} className="day-row">
//                     <div className="day-cell">
//                       <span className="day-name">{date.toLocaleDateString('en-US', { weekday: 'short' })}</span>
//                       <span className={`day-number ${isToday(date) ? 'today' : ''}`}>{date.getDate()}</span>
//                       <span style={{ fontSize: 11, color: '#6b7280' }}>{display.attendance_date}</span>
//                     </div>

//                     <div className="time-info">
//                       <span className="time-value">{display.check_in_time ? formatAMPM(display.check_in_time) : '--:--'}</span>
//                       {lateBy && <span className="time-label late">Late {lateBy}</span>}
//                       {isAbsent && <span className="time-label late">Absent</span>}
//                     </div>

//                     <div className="time-info">
//                       <span className="time-value">{display.check_out_time ? formatAMPM(display.check_out_time) : '--:--'}</span>
//                       {earlyBy && <span className="time-label early">Early {earlyBy}</span>}
//                     </div>

//                     <div className="hours-worked">
//                       <div>{display.working_hours ? `${display.working_hours} Hrs` : '00:00'}</div>
//                       {!isWeekend && (
//                         <div style={{ fontSize: '12px', color: isAbsent ? '#e74c3c' : '#6b7280' }}>
//                           {display.status}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })
//             ) : (
//               filteredUser
//                 .filter((r) => r.attendance_date >= monthStartStr && r.attendance_date <= monthEndStr)
//                 .sort((a, b) => a.attendance_date.localeCompare(b.attendance_date))
//                 .map((record) => {
//                   const { lateBy, earlyBy } = calculateLateEarly(record);
//                   return (
//                     <div key={record.id} className="day-row">
//                       <div className="day-cell">
//                         <span className="day-name">{record.attendance_date}</span>
//                       </div>

//                       <div className="time-info">
//                         <span className="time-value">{record.check_in_time ? formatAMPM(record.check_in_time) : '--:--'}</span>
//                         {lateBy && <span className="time-label late">Late {lateBy}</span>}
//                       </div>

//                       <div className="time-info">
//                         <span className="time-value">{record.check_out_time ? formatAMPM(record.check_out_time) : '--:--'}</span>
//                         {earlyBy && <span className="time-label early">Early {earlyBy}</span>}
//                       </div>

//                       <div className="hours-worked">
//                         <div>{record.working_hours ? `${record.working_hours} Hrs` : '00:00'}</div>
//                         <div style={{ fontSize: '12px', color: '#6b7280' }}>
//                           {record.status || (record.check_in_time ? 'Present' : 'Absent')}
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }
import { useState, useEffect } from 'react';
import '../Assests/Attendance.css';
import {
  getAttendanceByProfile,
  getTodayAttendance,
  checkInUser,
  checkOutUser,
  autoClosePastSessions,
  getAttendance
} from '../Db_Connections/AttendanceApi';

// 🔹 Shift: 10:00 AM to 7:30 PM
const SHIFT_START_HOUR = 10;
const SHIFT_START_MINUTE = 0;
const SHIFT_END_HOUR = 19;
const SHIFT_END_MINUTE = 30;

export default function Attendance() {
  // ✅ view + week/month selection
  const [viewMode, setViewMode] = useState('week'); // 'week' | 'month'
  const [selectedWeekOffset, setSelectedWeekOffset] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  });    

  // ✅ user dropdown selection
  const [selectedUserKey, setSelectedUserKey] = useState('ALL'); // 'ALL' | employeeName string

  // User view data
  const [dbData, setDbData] = useState([]);
  const [todayRecord, setTodayRecord] = useState(null);

  // Admin view data
  const [adminData, setAdminData] = useState([]);
  const [adminLoading, setAdminLoading] = useState(false);

  // Timer (user only)
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  const user = JSON.parse(sessionStorage.getItem('auth'));
  const isAdmin = user?.role === 'Admin';

  const currentUserName =
    user?.first_name || user?.last_name
      ? `${user?.first_name || ''} ${user?.last_name || ''}`.trim()
      : (user?.name || user?.email || 'User');

  // ============ DATE HELPERS ============
  const getWeekDatesByOffset = (weekOffset) => {
    const today = new Date();
    const currentDay = today.getDay();
    const diff = today.getDate() - currentDay + (weekOffset * 7);
    const weekStart = new Date(today.setDate(diff));
    const days = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(weekStart);
      d.setDate(weekStart.getDate() + i);
      days.push(d);
    }
    return days;
  };

  const weekDates = getWeekDatesByOffset(selectedWeekOffset);
  const startDate = weekDates[0];
  const endDate = weekDates[6];
  const startStr = startDate.toISOString().split('T')[0];
  const endStr = endDate.toISOString().split('T')[0];

  const getMonthRange = (yyyymm) => {
    const [y, m] = yyyymm.split('-').map(Number);
    const end = new Date(y, m, 0);
    const startS = `${y}-${String(m).padStart(2, '0')}-01`;
    const endS = `${y}-${String(m).padStart(2, '0')}-${String(end.getDate()).padStart(2, '0')}`;
    return { startS, endS };
  };

  const { startS: monthStartStr, endS: monthEndStr } = getMonthRange(selectedMonth);

  const formatDateRange = () =>
    `${startDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })} - ${endDate.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    })}`;

  const isToday = (date) => {
    const t = new Date();
    return date.getDate() === t.getDate() && date.getMonth() === t.getMonth() && date.getFullYear() === t.getFullYear();
  };

  const formatTime = (totalSeconds) => {
    const h = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
    const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const s = String(totalSeconds % 60).padStart(2, '0');
    return `${h}:${m}:${s}`;
  };

  const formatAMPM = (dateStr) => {
    if (!dateStr) return '--:--';
    return new Date(dateStr).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
  };

  const calculateLateEarly = (record) => {
    let lateBy = null;
    let earlyBy = null;

    if (record.check_in_time) {
      const checkIn = new Date(record.check_in_time);
      const shiftStart = new Date(checkIn);
      shiftStart.setHours(SHIFT_START_HOUR, SHIFT_START_MINUTE, 0);
      if (checkIn > shiftStart) {
        const diff = Math.floor((checkIn - shiftStart) / 1000);
        lateBy = formatTime(diff);
      }
    }

    if (record.check_out_time) {
      const checkOut = new Date(record.check_out_time);
      const shiftEnd = new Date(checkOut);
      shiftEnd.setHours(SHIFT_END_HOUR, SHIFT_END_MINUTE, 0);
      if (checkOut < shiftEnd) {
        const diff = Math.floor((shiftEnd - checkOut) / 1000);
        earlyBy = formatTime(diff);
      }
    }
  
  return { lateBy, earlyBy };
  };

  // ============ FETCH USER ============
  const fetchUserAttendanceData = async () => {
    if (!user) return;

    await autoClosePastSessions(user.id);

    const { data } = await getAttendanceByProfile(user.id);
    if (data) setDbData(data);


    const { data: today } = await getTodayAttendance(user.id);
    if (today) {
      setTodayRecord(today);

      if (today.check_in_time && !today.check_out_time) {
        const startTime = new Date(today.check_in_time).getTime();
        const now = new Date().getTime();
        const diffSec = Math.floor((now - startTime) / 1000);
        setElapsedSeconds(diffSec > 0 ? diffSec : 0);
        setIsTimerRunning(true);
      } else if (today.working_hours) {
        setIsTimerRunning(false);
        setElapsedSeconds(Number(today.working_hours) * 3600);
      }
    } else {
      setTodayRecord(null);
      setIsTimerRunning(false);
      setElapsedSeconds(0);
    }
  };

  // ============ FETCH ADMIN ============
  const fetchAdminData = async () => {
    setAdminLoading(true);
    try {
      const res = await getAttendance();
      setAdminData(res?.data || []);
    } finally {
      setAdminLoading(false);
    }
  };

  useEffect(() => {
    if (!user) return;

    // ✅ Admin ko bhi apna today attendance chahiye (check-in/out ke liye)
    fetchUserAttendanceData();

    // ✅ Admin view (all employees) bhi chahiye
    if (isAdmin) fetchAdminData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);
  // ============ TIMER (USER ONLY) ============
  useEffect(() => {
    let intervalId;
    if (isTimerRunning) {
      intervalId = setInterval(() => setElapsedSeconds((prev) => prev + 1), 1000);
    }
    return () => clearInterval(intervalId);
  }, [isTimerRunning]);

  // ============ CHECK-IN / CHECK-OUT (USER ONLY) ============
  const handleCheckInOut = async () => {
    if (!user) return;

    if (!isTimerRunning && (!todayRecord || !todayRecord.check_out_time)) {
      const { data, error } = await checkInUser(user.id);
      if (error) alert("Error Checking In: " + error.message);
      else {
        setTodayRecord(data);
        setElapsedSeconds(0);
        setIsTimerRunning(true);
        fetchUserAttendanceData();
      }
    } else if (isTimerRunning) {
      const { data, error } = await checkOutUser(todayRecord.id);
      if (error) alert("Error Checking Out: " + error.message);
      else {
        setIsTimerRunning(false);
        setTodayRecord(data);
        fetchUserAttendanceData();
        alert(`Checked Out Successfully!\nDate: ${data.attendance_date}\nWorking Hours: ${data.working_hours} hrs`);
      }
    }
  };

  // ============ TODAY SUMMARY (USER) ============
  const todaySummary = todayRecord
    ? {
      checkIn: formatAMPM(todayRecord.check_in_time),
      checkOut: todayRecord.check_out_time ? formatAMPM(todayRecord.check_out_time) : '--:--',
      hours: isTimerRunning ? formatTime(elapsedSeconds) : (todayRecord.working_hours ? `${todayRecord.working_hours} hrs` : '00:00:00')
    }
    : { checkIn: '--:--', checkOut: '--:--', hours: '00:00:00' };

  const todayLabel = new Date().toLocaleDateString('en-GB', { weekday: 'short', day: '2-digit', month: 'short' });

  // ============ FILTER DATA BY WEEK/MONTH ============
  const inSelectedRange = (row) => {
    if (viewMode === 'week') return row.attendance_date >= startStr && row.attendance_date <= endStr;
    return row.attendance_date >= monthStartStr && row.attendance_date <= monthEndStr;
  };

  const filteredUser = dbData.filter(inSelectedRange);

  // ✅ Admin filtered (range + optional selected user)
  const filteredAdmin = adminData
    .filter(inSelectedRange)
    .filter((row) => {
      if (selectedUserKey === 'ALL') return true;
      const employeeName = row?.profiles
        ? `${row.profiles.first_name || ''} ${row.profiles.last_name || ''}`.trim()
        : `Employee (${row.profile_id})`;
      return employeeName === selectedUserKey;
    });

  // ============ ADMIN GROUP ============
  const buildAdminRowsByEmployee = () => {
    const empMap = {};
    filteredAdmin.forEach((row) => {
      const employeeName = row?.profiles
        ? `${row.profiles.first_name || ''} ${row.profiles.last_name || ''}`.trim()
        : `Employee (${row.profile_id})`;

      if (!empMap[employeeName]) empMap[employeeName] = {};
      empMap[employeeName][row.attendance_date] = row;
    });

    return Object.entries(empMap).map(([name, byDate]) => ({ name, byDate }));
  };

  const adminEmployees = buildAdminRowsByEmployee();

  // ✅ Build dropdown users list (adminData se)
  const adminUserOptions = (() => {
    const set = new Set();
    adminData.forEach((row) => {
      const name = row?.profiles
        ? `${row.profiles.first_name || ''} ${row.profiles.last_name || ''}`.trim()
        : null;
      if (name) set.add(name);
    });
    return Array.from(set).sort((a, b) => a.localeCompare(b));
  })();

  const buildMonths = () => {
    const y = new Date().getFullYear();
    const months = [];
    for (let m = 1; m <= 12; m++) {
      const value = `${y}-${String(m).padStart(2, '0')}`;
      const label = new Date(y, m - 1, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
      months.push({ value, label });
    }
    return months;
  };

  const weekOptions = [
    { value: 0, label: 'Week 1 (Current)' },
    { value: -1, label: 'Week 2 (Last Week)' },
    { value: -2, label: 'Week 3' },
    { value: -3, label: 'Week 4' },
  ];

  return (
    <div className="page-container">
      <div className="tabs-container">
        <div className="tab active">
          {isAdmin ? "All Employees Attendance Summary" : "Attendance Summary"}
        </div>
      </div>

      <div className="content-wrapper">
        {/* ✅ DROPDOWNS: Name + Week/Month */}
        <div className="attendance-filters">
          {/* ✅ Name dropdown */}
          <select
            className="attendance-select user-select"
            value={selectedUserKey}
            onChange={(e) => setSelectedUserKey(e.target.value)}
            disabled={!isAdmin}
          >
            {isAdmin && <option value="ALL">All Employees</option>}
            {!isAdmin && <option value={currentUserName}>{currentUserName}</option>}

            {isAdmin && adminUserOptions.map((name) => (
              <option key={name} value={name}>{name}</option>
            ))}
          </select>

          <select
            className="attendance-select"
            value={viewMode}
            onChange={(e) => setViewMode(e.target.value)}
          >
            <option value="week">Week</option>
            <option value="month">Month</option>
          </select>

          {viewMode === 'week' ? (
            <select
              className="attendance-select"
              value={selectedWeekOffset}
              onChange={(e) => setSelectedWeekOffset(Number(e.target.value))}
            >
              {weekOptions.map((w) => (
                <option key={w.value} value={w.value}>{w.label}</option>
              ))}
            </select>
          ) : (
            <select
              className="attendance-select"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              {buildMonths().map((m) => (
                <option key={m.value} value={m.value}>{m.label}</option>
              ))}
            </select>
          )}
        </div>

        {/* Header range */}
        {viewMode === 'week' && (
          <div className="schedule-header">
            <div className="date-navigation">
              <button className="nav-btn" onClick={() => setSelectedWeekOffset((c) => c - 1)}>‹</button>
              <button className="calendar-icon-btn">📅</button>
              <button className="nav-btn" onClick={() => setSelectedWeekOffset((c) => c + 1)}>›</button>
              <span className="date-range">{formatDateRange()}</span>
            </div>
          </div>
        )}

        {/* ✅ USER: check-in UI (admin hidden) */}
        {/* ✅ Check-in UI: admin + user dono ke liye */}
        {user && (
          <>
            <div className="shift-info-card">
              <div className="shift-details">
                <span className="shift-name">General [  10:00 AM - 07:30 PM ]</span>
                <input type="text" className="notes-input" placeholder="Add notes (optional)" />
              </div>

              <button
                className="check-in-btn"
                onClick={handleCheckInOut}
                style={{ background: isTimerRunning ? '#e74c3c' : '#27ae60' }}
                disabled={todayRecord?.check_out_time}
              >
                <span>
                  {todayRecord?.check_out_time
                    ? "Completed"
                    : (isTimerRunning ? "Check Out" : "Check In")}
                </span>

                <span className="check-in-time">{formatTime(elapsedSeconds)} Hrs</span>
              </button>
            </div>

            <div className="today-summary-card">
              <div className="today-left">
                <div className="today-day">{todayLabel}</div>
              </div>

              <div className="today-right">
                <div className="today-row"><span>Check-in</span><span>{todaySummary.checkIn}</span></div>
                <div className="today-row"><span>Check-out</span><span>{todaySummary.checkOut}</span></div>
                <div className="today-row"><span>Working Hrs</span><span>{todaySummary.hours}</span></div>
              </div>
            </div>
          </>
        )}

        {/* ✅ ADMIN VIEW */}
        {isAdmin ? (
          <div className="attendance-container">
            {adminLoading ? (
              <div style={{ padding: 12 }}>Loading...</div>
            ) : adminEmployees.length === 0 ? (
              <div style={{ padding: 12 }}>No attendance data found.</div>
            ) : (
              adminEmployees.map((emp) => (
                <div key={emp.name} style={{ marginBottom: 18 }}>
                  <div style={{ padding: '10px 12px', fontWeight: 800 }}>👤 {emp.name}</div>

                  {viewMode === 'week' ? (
                    weekDates.map((date, idx) => {
                      const dateStr = date.toISOString().split('T')[0];
                      const isWeekend = idx === 0;
                      const record = emp.byDate[dateStr];
                      const isAbsent = !isWeekend && !record;

                      const display = record || {
                        attendance_date: dateStr,
                        status: isAbsent ? 'Absent' : (isWeekend ? 'Weekend' : 'No Data'),
                        check_in_time: null,
                        check_out_time: null,
                        working_hours: null,
                      };

                      const { lateBy, earlyBy } = record ? calculateLateEarly(record) : { lateBy: null, earlyBy: null };

                      return (
                        <div key={dateStr} className="day-row">
                          <div className="day-cell">
                            <span className="day-name">{date.toLocaleDateString('en-US', { weekday: 'short' })}</span>
                            <span className={`day-number ${isToday(date) ? 'today' : ''}`}>{date.getDate()}</span>
                            <span style={{ fontSize: 11, color: '#6b7280' }}>{display.attendance_date}</span>
                          </div>

                          <div className="time-info">
                            <span className="time-value">{display.check_in_time ? formatAMPM(display.check_in_time) : '--:--'}</span>
                            {lateBy && <span className="time-label late">Late {lateBy}</span>}
                            {isAbsent && <span className="time-label late">Absent</span>}
                          </div>

                          <div className="time-info">
                            <span className="time-value">{display.check_out_time ? formatAMPM(display.check_out_time) : '--:--'}</span>
                            {earlyBy && <span className="time-label early">Early {earlyBy}</span>}
                          </div>

                          <div className="hours-worked">
                            <div>{display.working_hours ? `${display.working_hours} Hrs` : '00:00'}</div>
                            {!isWeekend && (
                              <div style={{ fontSize: '12px', color: isAbsent ? '#e74c3c' : '#6b7280' }}>
                                {display.status}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    Object.values(emp.byDate)
                      .filter((r) => r.attendance_date >= monthStartStr && r.attendance_date <= monthEndStr)
                      .sort((a, b) => a.attendance_date.localeCompare(b.attendance_date))
                      .map((record) => {
                        const { lateBy, earlyBy } = calculateLateEarly(record);
                        return (
                          <div key={record.id} className="day-row">
                            <div className="day-cell">
                              <span className="day-name">{record.attendance_date}</span>
                            </div>

                            <div className="time-info">
                              <span className="time-value">{record.check_in_time ? formatAMPM(record.check_in_time) : '--:--'}</span>
                              {lateBy && <span className="time-label late">Late {lateBy}</span>}
                            </div>

                            <div className="time-info">
                              <span className="time-value">{record.check_out_time ? formatAMPM(record.check_out_time) : '--:--'}</span>
                              {earlyBy && <span className="time-label early">Early {earlyBy}</span>}
                            </div>

                            <div className="hours-worked">
                              <div>{record.working_hours ? `${record.working_hours} Hrs` : '00:00'}</div>
                              <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                {record.status || (record.check_in_time ? 'Present' : 'Absent')}
                              </div>
                            </div>
                          </div>
                        );
                      })
                  )}
                </div>
              ))
            )}
          </div>
        ) : (
          // ✅ USER VIEW
          <div className="attendance-container">
            {viewMode === 'week' ? (
              weekDates.map((date, index) => {
                const dateStr = date.toISOString().split('T')[0];
                const record = filteredUser.find(d => d.attendance_date === dateStr);

                const isWeekend = index === 0;
                const isAbsent = !isWeekend && !record;

                const display = record || {
                  attendance_date: dateStr,
                  status: isAbsent ? 'Absent' : (isWeekend ? 'Weekend' : 'No Data'),
                  check_in_time: null,
                  check_out_time: null,
                  working_hours: null,
                };

                const { lateBy, earlyBy } = record ? calculateLateEarly(record) : { lateBy: null, earlyBy: null };

                return (
                  <div key={index} className="day-row">
                    <div className="day-cell">
                      <span className="day-name">{date.toLocaleDateString('en-US', { weekday: 'short' })}</span>
                      <span className={`day-number ${isToday(date) ? 'today' : ''}`}>{date.getDate()}</span>
                      <span style={{ fontSize: 11, color: '#6b7280' }}>{display.attendance_date}</span>
                    </div>

                    <div className="time-info">
                      <span className="time-value">{display.check_in_time ? formatAMPM(display.check_in_time) : '--:--'}</span>
                      {lateBy && <span className="time-label late">Late {lateBy}</span>}
                      {isAbsent && <span className="time-label late">Absent</span>}
                    </div>

                    <div className="time-info">
                      <span className="time-value">{display.check_out_time ? formatAMPM(display.check_out_time) : '--:--'}</span>
                      {earlyBy && <span className="time-label early">Early {earlyBy}</span>}
                    </div>

                    <div className="hours-worked">
                      <div>{display.working_hours ? `${display.working_hours} Hrs` : '00:00'}</div>
                      {!isWeekend && (
                        <div style={{ fontSize: '12px', color: isAbsent ? '#e74c3c' : '#6b7280' }}>
                          {display.status}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              filteredUser
                .filter((r) => r.attendance_date >= monthStartStr && r.attendance_date <= monthEndStr)
                .sort((a, b) => a.attendance_date.localeCompare(b.attendance_date))
                .map((record) => {
                  const { lateBy, earlyBy } = calculateLateEarly(record);
                  return (
                    <div key={record.id} className="day-row">
                      <div className="day-cell">
                        <span className="day-name">{record.attendance_date}</span>
                      </div>

                      <div className="time-info">
                        <span className="time-value">{record.check_in_time ? formatAMPM(record.check_in_time) : '--:--'}</span>
                        {lateBy && <span className="time-label late">Late {lateBy}</span>}
                      </div>

                      <div className="time-info">
                        <span className="time-value">{record.check_out_time ? formatAMPM(record.check_out_time) : '--:--'}</span>
                        {earlyBy && <span className="time-label early">Early {earlyBy}</span>}
                      </div>

                      <div className="hours-worked">
                        <div>{record.working_hours ? `${record.working_hours} Hrs` : '00:00'}</div>
                        <div style={{ fontSize: '12px', color: '#6b7280' }}>
                          {record.status || (record.check_in_time ? 'Present' : 'Absent')}
                        </div>
                      </div>
                    </div>
                  );
                })
            )}
          </div>
        )}
      </div>
    </div>
  );
}